
if(window.location.href.includes('bfcm.theayurvedaexperience.fr')){


  document.addEventListener('DOMContentLoaded', function () {
    // Shopify store URL
    const shopifyStoreUrl = 'https://theayurvedaexperience.fr';

    // Select all elements with `data-pf-type="ProductATC"` and add the class "add-to-cart-button" to them
    const productATCButtons = document.querySelectorAll('[data-pf-type="ProductATC"]');
    productATCButtons.forEach(button => button.classList.add('add-to-cart-button'));

    // Find all "add-to-cart-button" elements and set up click event listeners
    document.querySelectorAll('.add-to-cart-button').forEach((button, index) => {
        button.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default behavior (e.g., page reload)

            // Fetch the specific quantity input field associated with this button
            const quantityInputs = document.querySelectorAll('[data-pf-type="ProductQuantity"] input');
            const quantityInput = quantityInputs[index]?.value || 1; // Default to 1 if no input found

            // Fetch the variant ID from the corresponding element with `data-default-variant`
            const variantIds = document.querySelectorAll('[data-default-variant]');
            const variantId = variantIds[index]?.getAttribute('data-default-variant');

            // Check if the variant ID and quantity are correctly fetched
            console.log("Variant ID:", variantId);
            console.log("Quantity:", quantityInput);

            let url = window.location.href;

            // Extract the last part after the last "?"
            let extractedPart = url.substring(url.lastIndexOf('?') + 1);
          

            // Construct the cart URL with the specific variant ID, quantity, and UTM parameters
            if (variantId) {
                const cartUrl = `${shopifyStoreUrl}/cart/add?id=${variantId}&quantity=${quantityInput}&url.substring(url.lastIndexOf('?') + 1)`;
                console.log("myNewUrl", cartUrl);

                // Redirect to the constructed URL
                window.location.href = cartUrl;
            } else {
                console.warn("Variant ID not found for the selected product.");
            }
        });
    });
});



///Anchor redirect

document.addEventListener('DOMContentLoaded', () => {
  // Select all anchor tags on the page
  const anchors = document.querySelectorAll('a');

  // Loop through each anchor and modify the href if it starts with '/'
  anchors.forEach(anchor => {
    if (anchor.getAttribute('href') && anchor.getAttribute('href').startsWith('/')) {
      anchor.setAttribute('href', 'https://theayurvedaexperience.fr' + anchor.getAttribute('href'));
    }
  });
});






// Redirect URL for search
const redirectURL = 'https://theayurvedaexperience.fr/pages/search-results-page?type=product';

const url = window.location.href;
const subdomainToCheck = "bfcm.theayurvedaexperience.fr";

checkSubdomain(url, subdomainToCheck);

function checkSubdomain(url, subdomainToCheck) {
    if (url.includes(subdomainToCheck)) {
        document.addEventListener('DOMContentLoaded', function() {
            // Handle search form overlay redirection
            const searchForm = document.querySelector('.search_form');
            if (searchForm) {
                const overlay = document.createElement('div');
                overlay.className = 'clickable-overlay';
                searchForm.appendChild(overlay);
                overlay.addEventListener('click', function() {
                    window.location.href = redirectURL;
                });
            }


            // Handle multiple anchor tags with .icon-search.dropdown_link
            const anchorTags = document.querySelectorAll('.icon-search.dropdown_link');
            anchorTags.forEach((anchor, index) => {
                anchor.addEventListener('click', function(event) {
                    event.preventDefault(); // Prevent the default anchor behavior
                    console.log(`Redirecting from anchor ${index + 1}`);
                    window.location.href = redirectURL;
                });
            });
        });
    }
}

// Elevar
  

}